import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const CommonHistoryLogRequest = {
  getList: document_code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/common_history_log/${document_code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

    
  getLists: document_code =>
  axios({
    method: 'get',
    url: `${apiUrl}/api/v1/common_history_log?documentCode=${document_code}`,
    headers: {
      Authorization: `Bearer ${
        JSON.parse(authenticationStore.appToken).access_token
      }`,
      'Content-Type': 'application/json',
    },
  }),
}
